<template>
	<div class="page-container">
		<div v-show="$store.state.cart.products.length">
			<h1>Your Shopping Cart</h1>
			<div class="products">
				<div class="paper surface" :key="index" v-for="(product, index) in $store.state.cart.products">


					<div class="product">
						<div class="image-and-name">
							<n-link :to="localePath({name: 'product', query: { id: product.product_id }})">
								<img :src="product.image_base + '/180custom/' + product.image" alt="">
							</n-link>
							<div>
								<n-link :to="localePath({name: 'product', query: { id: product.product_id }})">{{ product.name }}</n-link>
								<div v-if="product.size_id > 1">
									<span class="faded">Size:</span> {{ product.size.size }}
								</div>
							</div>
						</div>
						<div class="align-right remove_button">
							<button class="outlined-button" @click="remove_product( product )" title="Remove Product"><img src="~assets/icons/trash-bin.svg" alt="Remove Product"></button>
						</div>
						<div class="modifiers">
							<div v-if="product.lock_quantity">
								{{ product.quantity }}
							</div>
							<select @change="change_quantity($event, index, product)" v-else>
								<option v-for="(price, index) in product.prices" :key="index" :selected="product.quantity == price.min">{{ price.min }}</option>
							</select>
						</div>
						<div class="align-right product-price">
							<div>
								<div class="price product-total">
									<currency :value="product.price * product.quantity" type="total"/>
								</div>
								<div class="faded">per unit <currency :value="product.price"/></div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="paper surface">
				<div class="summary subtotal">
					<label class="faded">
						Subtotal ({{$store.state.cart.products.length}} item<span v-show="$store.state.cart.products.length > 1">s</span>)
					</label>
					<div class="price">
						<currency :value="$store.state.cart.product_subtotal"/>
					</div>
				</div>
				<div class="primary-actions">
					<n-link class="button text-button" :to="localePath('search')">Continue Shopping</n-link>
					<n-link class="button" :to="localePath('delivery-details')">
						<span class="desktop">Delivery and Payment</span>
						<span class="mobile">Checkout</span>
					</n-link>
				</div>
			</div>
		</div>
		<div class="split-pair empty-cart" v-show="$store.state.cart.products.length == 0">
			<div>
				<h1>Your shopping cart is empty.</h1>
				<p>Add items to the cart and buy them quickly and conveniently.</p>
			</div>
			<div>
				<img src="~/assets/cart.jpg" alt="small empty metal shopping cart">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	head: {
		title: 'Cart',
	},
	methods: {
		product_total( product ) {
			let total = parseFloat((product.quantity * product.price).toFixed(2));
			return total;
		},
		change_quantity( event, index, product ) {
			const quantity = this.validate_quantity(product.prices, event.target.value | 0);
			this.$store.commit('cart/change_quantity', { index, quantity });
		},
		remove_product( product ) {
			if ( product.lock_quantity && !confirm("Warning: Removing this product from your cart will also remove any variants added to your cart at the same time as it.") ) {
				return;
			}
			this.$store.commit('cart/remove_product', product.id );
		},
		product_url(product) {
			let url = '?';
			if( product.colour != null ) {
				url += (product.colour.colour ? 'colour=' + product.colour.colour : '');
			}
			if ( product.size_id && product.size_id > 1 ) {
				url += '&size=' + product.size.size;
			}
			return url;
		},
	},
};
</script>

<style scoped>
h1 {
	font-size: 30px;
	margin: 0 0 16px;
}
legend {
	font-size: 0.9em;
}
.surface, .empty-cart {
	padding: 16px;
}
.split-pair {
	align-items: center;
}
.split-pair > div {
	width: 50%;
}
.empty-cart img {
	max-width: 100%;
	width: 100%;
}

.products > div {
	margin: 0 0 16px;
}

.product {
	display: flex;
	flex-grow: 1;
	flex-wrap: wrap;
	margin-bottom: 16px;
}
.image-and-name {
	order: -1;
	display: flex;
	align-items: center;
	padding-left: 16px;

	flex-basis: 91.66667%;
	max-width: 91.66667%;
	width: 91.66667%;
}
.image-and-name img {
	max-height: 64px;
	margin-right: 8px;
}
.remove_button {
	order: -1;
	display: flex;
	align-items: center;
	padding-left: 8px;

	flex-basis: 8.33333%;
	max-width: 8.33333%;
	width: 8.33333%;
}
.remove_button button {
	border: none;
	box-shadow: none;
	min-width: 32px;
	min-height: 32px;
	padding: 0;
}
.remove_button button:hover {
	background: none;
}
.remove_button img {
	width: 32px;
	height: 32px;
}
.modifiers {
	padding-left: 16px;
}
.quantity-changer {
	margin-right: 8px;
}
.product-price {
	margin-left: auto;
}
.product-price > div {
	margin-left: auto;
}
.modifiers, .product-price {
	order: -1;
	flex-basis: 50%;
	max-width: 50%;
	width: 50%;
	display: inline-flex;
	align-items: center;
}

.price {
	font-size: 24px;
}
.faded {
	font-size: 0.7em;
}

.primary-actions {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
}
.primary-actions > * {
	width: 100%;
	margin: 5px;
}
.primary-actions > *:first-child {
	order: 1;
}
.price_inline {
	display: inline-block;
}
.location {
	text-transform: uppercase;
}
.price {
	margin: 0 0 0 16px;
}
.subtotal {
	margin-bottom: 16px;
}
.product-summary {
	border-top: 1px solid #aaa;
	padding: 16px 0 0;
}
@media (min-width: 576px) {
	.primary-actions {
		flex-wrap: nowrap;
	}
	.primary-actions > * {
		width: 50%;
	}
	.primary-actions > *:first-child {
		order: -1;
	}
}
@media (min-width: 768px) {
	.remove_button {
		order: 0;
	}
	.image-and-name {
		flex-basis: 50%;
		max-width: 50%;
		width: 50%;
	}
	.remove_button, .modifiers, .product-price {
		flex-basis: unset;
		max-width: unset;
		width: unset;
	}
	.faded {
		font-size: 1em;
	}
}
</style>
